<template>
  <div class="relative rounded-lg transition-all" v-if="investments.length">
    <div
      class="dark:bg-ontick-steel-500 sticky top-0 left-0 z-20 grid rounded-t-lg bg-gray-300"
      :class="numberOfColumns"
    >
      <div class="th" scope="col">
        <span class="sr-only"> Ações </span>
      </div>
      <button
        class="th flex items-center space-x-1"
        :class="[
          item.label === 'Nome' ? 'justify-start' : 'justify-center',
          item.label === 'Nome' ? nameColumnSize : '',
        ]"
        v-for="item in filteredHeader"
        :key="item.label"
        @click="sort(item.key)"
      >
        <span v-if="item.key === sortKey">
          {{ sortIcon }}
        </span>
        <p :content="item.tooltip" v-tippy="{ arrow: true, theme: 'green' }">
          {{ item.label }}
        </p>
      </button>
    </div>

    <transition-group
      name="slide-in"
      class="divide-ontick-steel-300 dark:divide-ontick-steel-500 dark:bg-ontick-graphite-500 flex w-full flex-col divide-y rounded-b-lg bg-gray-200"
    >
      <template v-for="investment in sortedData">
        <list-item-component
          :key="investment.investment_id"
          :investment="investment"
          @toggle-portfolio-dropdown="togglePortfolioDropdown($event)"
          @toggleSwitch="toggleSwitch"
        />

        <template
          v-if="
            investment.type === 'PORTFOLIO' &&
            portfolioDropdowns[
              portfolioDropdowns.findIndex(
                (item) => item.id === investment.investment_id
              )
            ].dropdownActive
          "
        >
          <list-dropdown-item-component
            v-for="component in investment.components"
            :key="component.investment_id"
            :investment="component"
            class="row"
          />
        </template>
      </template>
    </transition-group>
  </div>
</template>

<script>
import ListDropdownItemComponent from "../running/list-dropdown-item.component.vue";
import ListItemComponent from "../running/list-item.component.vue";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import EventBus from "@/app/shared/utils/event_bus.js";

export default {
  components: {
    ListItemComponent,
    ListDropdownItemComponent,
    CollapseTransition,
  },
  props: {
    investments: {
      type: Array,
    },
  },
  data() {
    return {
      header: [
        { label: "ID", tooltip: "ID da estratégia", key: "id" },
        { label: "Tipo", tooltip: "Tipo de produto", key: "type" },
        { label: "Nome", tooltip: "Nome da estratégia", key: "strategy_name" },
        {
          label: "Ativo",
          tooltip: "Ativo operado pela estratégia",
          key: "strategy_symbol",
        },
        {
          label: "TF",
          tooltip: "Timeframe",
          key: "strategy_timeframe",
        },
        {
          label: "Posição",
          tooltip: "Status da posição",
          key: "position_status",
        },
        {
          label: "Volume",
          tooltip: "Volume posicionados/parametrizados",
          key: "param_volume",
        },
        {
          label: "Resultado",
          tooltip: "Resultado da operação em aberto",
          key: "open_pnl",
        },
        {
          label: "Acumulado",
          tooltip: "Resultado acumulado do dia",
          key: "closed_pnl",
        },
        { label: "Status", tooltip: "Status da estratégia" },
        {
          label: "Perda máx.",
          tooltip: "Ganho máximo diário",
          key: "max_daily_loss",
        },
        {
          label: "Ganho máx.",
          tooltip: "Perda máxima diária",
          key: "max_daily_gain",
        },
      ],
      portfolioDropdowns: [
        ...this.investments
          .filter((item) => item.type === "PORTFOLIO")
          .map((item) => {
            return { id: item.investment_id, dropdownActive: false };
          }),
      ],
      listModeColumns: localStorage.getItem("listModeColumns")
        ? localStorage.getItem("listModeColumns").split(",")
        : null,
      sortDirection: "",
      sortKey: "",
    };
  },

  computed: {
    nameColumnSize() {
      if (this.listModeColumns.length > 6) {
        return "col-span-1";
      } else {
        return "col-span-2";
      }
    },
    numberOfColumns() {
      if (this.listModeColumns) {
        if (this.listModeColumns.length > 6) {
          return `grid-cols-${this.listModeColumns.length + 6}`;
        } else {
          return `grid-cols-${this.listModeColumns.length + 7}`;
        }
      } else {
        return "grid-cols-10";
      }
    },
    filteredHeader() {
      return [
        // { label: "ID", tooltip: "ID da estratégia", key: "id" },
        // { label: "Tipo", tooltip: "Tipo de produto", key: "type" },
        { label: "Nome", tooltip: "Nome da estratégia", key: "strategy_name" },
        {
          label: "Ativo",
          tooltip: "Ativo operado pela estratégia",
          key: "strategy_symbol",
        },
        {
          label: "TF",
          tooltip: "Timeframe",
          key: "strategy_timeframe",
        },
        {
          label: "Posição",
          tooltip: "Status da posição",
          key: "position_status",
        },
        {
          label: "Volume",
          tooltip: "Volume posicionados/parametrizados",
          key: "param_volume",
        },

        ...this.header.filter((item) =>
          this.listModeColumns.includes(item.label)
        ),
      ];
    },
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.investments.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.investments.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.investments;
      }
    },
  },

  methods: {
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
    },
    togglePortfolioDropdown(id) {
      let dropdownActive =
        this.portfolioDropdowns[
          this.portfolioDropdowns.findIndex((item) => item.id === id)
        ].dropdownActive;
      this.portfolioDropdowns[
        this.portfolioDropdowns.findIndex((item) => item.id === id)
      ].dropdownActive = !dropdownActive;
    },
    toggleSwitch({ investmentId, investmentStatus, toggle }) {
      if (!toggle) {
        this.$emit("electronicSignature", { investmentId, investmentStatus });
      }
    },
  },
  created() {
    EventBus.$on("UPDATE_LIST_COLUMNS", (value) => {
      this.listModeColumns = value.split(",");
    });
  },
};
</script>

<style lang="scss" scoped>
.th {
  @apply text-ontick-carbon-900 py-2 px-4 text-left text-sm font-bold dark:text-gray-300;
}
.slide-in {
  &-enter-active,
  &-leave-active {
    @apply h-10 transition-all duration-300 ease-in-out;
  }
  &-enter,
  &-leave-to {
    @apply h-0 -translate-y-full transform opacity-0;
  }
  &-move {
    @apply transition-all duration-300 ease-in-out;
  }
}
</style>
